import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30fc19f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Breeding season has not started yet", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("GO BACK")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Join our ")
const _hoisted_5 = {
  href: "https://discord.com/invite/N8AnA662Mx",
  target: "_blank"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Discord community")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" to know when the next breeding season starts. ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blocker-announcement-card-media" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("JOIN DISCORD")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Breeding ")
const _hoisted_11 = {
  href: "https://docs.houndrace.com/houndrace-docs/features/breeding",
  target: "_blank"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" FILTER ")
const _hoisted_13 = { class: "sort-by" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" RESET ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" SEARCH ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Connect with Metamask in order to view the breeding menu. ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Start breeding new hounds")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" BREED ")
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img__armor" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img__neon" }, null, -1))
const _hoisted_23 = { class: "hound-card__info" }
const _hoisted_24 = { style: {"display":"flex","justify-content":"center","flex-direction":"column","align-items":"center"} }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "USD", -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" MOUNT ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("No hounds found for the current query.")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Reset filters?")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_modal = _resolveComponent("n-modal")!
  const _component_info_icon = _resolveComponent("info-icon")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_icon_wrapper = _resolveComponent("n-icon-wrapper")!
  const _component_n_h3 = _resolveComponent("n-h3")!
  const _component_caret_down = _resolveComponent("caret-down")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_input_number = _resolveComponent("n-input-number")!
  const _component_n_input_group = _resolveComponent("n-input-group")!
  const _component_n_radio = _resolveComponent("n-radio")!
  const _component_n_radio_group = _resolveComponent("n-radio-group")!
  const _component_n_select = _resolveComponent("n-select")!
  const _component_arrow_up = _resolveComponent("arrow-up")!
  const _component_n_radio_button = _resolveComponent("n-radio-button")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_reset_icon = _resolveComponent("reset-icon")!
  const _component_search_icon = _resolveComponent("search-icon")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_n_popover = _resolveComponent("n-popover")!
  const _component_n_gi = _resolveComponent("n-gi")!
  const _component_n_grid = _resolveComponent("n-grid")!
  const _component_n_hr = _resolveComponent("n-hr")!
  const _component_n_pagination = _resolveComponent("n-pagination")!
  const _component_n_divider = _resolveComponent("n-divider")!
  const _component_breeding_list_dialog = _resolveComponent("breeding-list-dialog")!
  const _component_breeding_internal_dialog = _resolveComponent("breeding-internal-dialog")!
  const _component_breeding_mount_dialog = _resolveComponent("breeding-mount-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_modal, {
      class: "blocker-announcement",
      show: !_ctx.breedingSeasonActive
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_card, {
          segmented: {
          footer: 'soft',
          content: true
        },
          class: "blocker-announcement-card",
          size: _ctx.breakpoints.sDown.matches ? 'small' : 'medium'
        }, {
          header: _withCtx(() => [
            _createVNode(_component_n_space, { justify: "space-between" }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_n_button, {
                  type: "primary",
                  ghost: "",
                  onClick: _ctx.rerouteToRacing
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          action: _withCtx(() => [
            _createVNode(_component_n_space, { justify: "right" }, {
              default: _withCtx(() => [
                _createVNode(_component_n_button, {
                  onClick: _ctx.openDiscord,
                  type: "primary",
                  "attr-type": "submit"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_n_space, { vertical: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_n_alert, { type: "info" }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _createElementVNode("a", _hoisted_5, [
                      _createVNode(_component_n_text, { type: "info" }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["size"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_n_space, {
      justify: "space-between",
      align: "center",
      style: {"padding":"1.5rem"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_h3, {
          class: "thick-text",
          style: {"margin-bottom":"0"}
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _createElementVNode("a", _hoisted_11, [
              _createVNode(_component_n_icon_wrapper, {
                "border-radius": "100%",
                size: "14",
                style: {"margin-left":".1rem","background":"transparent","border":"1px solid white"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_icon, {
                    color: "white",
                    size: "10"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_info_icon)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_n_popover, {
          trigger: "click",
          placement: "bottom-end"
        }, {
          trigger: _withCtx(() => [
            _createVNode(_component_n_button, {
              size: "large",
              text: ""
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_n_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_caret_down)
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_n_form, {
              model: _ctx.filtersModel,
              ref: "formRef",
              onSubmit: _withModifiers(_ctx.search, ["prevent"]),
              style: {"max-width":"80vw"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_form_item, {
                  label: "Name",
                  path: "title"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_input, {
                      value: _ctx.filtersModel.title,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filtersModel.title) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, {
                  label: "Min Runs",
                  path: "title"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_input_number, {
                      min: 0,
                      value: _ctx.filtersModel.totalRuns,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filtersModel.totalRuns) = $event)),
                      style: {"width":"100%"}
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, { label: "Fee" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_input_group, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_input_number, {
                          value: _ctx.filtersModel.fee[0],
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filtersModel.fee[0]) = $event)),
                          placeholder: "Min",
                          min: "0"
                        }, null, 8, ["value"]),
                        _createVNode(_component_n_input_number, {
                          value: _ctx.filtersModel.fee[1],
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filtersModel.fee[1]) = $event)),
                          placeholder: "Max"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, {
                  label: "Gender",
                  path: "gender"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_radio_group, {
                      value: _ctx.filtersModel.gender,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filtersModel.gender) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_space, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genderTypes, (gender, i) => {
                              return (_openBlock(), _createBlock(_component_n_radio, {
                                key: i,
                                value: gender.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(gender.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_n_form_item, {
                    label: "Sort by",
                    path: "sort"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_select, {
                        value: _ctx.filtersModel.sort,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filtersModel.sort) = $event)),
                        options: _ctx.sortTypes
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_n_form_item, { path: "order" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_radio_group, {
                        value: _ctx.filtersModel.order,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filtersModel.order) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_n_radio_button, {
                            ghost: "",
                            value: "ASC"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_n_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_arrow_up)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_n_radio_button, { value: "DESC" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_n_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_arrow_down)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_n_form_item, { "show-feedback": false }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_space, {
                      justify: "right",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_button, { onClick: _ctx.resetFilters }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_n_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_reset_icon)
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _hoisted_14
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_n_button, { "attr-type": "submit" }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_n_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_search_icon)
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _hoisted_15
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "onSubmit"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (!_ctx.ethReactive.initialized)
      ? (_openBlock(), _createBlock(_component_n_alert, {
          key: 0,
          title: "Allow Connection",
          type: "warning"
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_n_grid, {
          key: 1,
          cols: "12",
          "x-gap": "24",
          "y-gap": "24",
          "item-responsive": "",
          responsive: "screen"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_gi, {
              span: "12",
              class: "hounds-table"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_card, {
                  size: _ctx.breakpoints.sDown.matches ? 'small' : 'medium',
                  style: {"background":"rgba(0, 0, 0, .5)"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_grid, {
                      cols: "12",
                      "item-responsive": "",
                      responsive: "screen",
                      "y-gap": "24"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_gi, {
                          span: "12 m:6",
                          style: {"align-self":"center"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_n_text, { strong: "" }, {
                              default: _withCtx(() => [
                                _hoisted_17
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_n_gi, { span: "12 m:6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_n_space, {
                              justify: "space-between",
                              align: "center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_n_radio_group, {
                                  value: _ctx.breedingType,
                                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.breedingType) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_n_space, null, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breedingTypes, (bType) => {
                                          return (_openBlock(), _createBlock(_component_n_radio, {
                                            key: bType.value,
                                            value: bType.value
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(bType.label), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"]),
                                _createVNode(_component_n_button, {
                                  type: "primary",
                                  onClick: _ctx.openListModal
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_18
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["size"]),
                _createVNode(_component_n_hr, { style: {"margin":"1.5rem 0"} }),
                (_ctx.hounds.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hounds, (hound) => {
                        return (_openBlock(), _createBlock(_component_n_card, {
                          class: "hound-card-container",
                          onClick: ($event: any) => (_ctx.openHound(hound.id.toString())),
                          key: hound.id,
                          style: {"margin-bottom":"1.5rem"},
                          hoverable: "",
                          size: _ctx.breakpoints.sDown.matches ? 'small' : 'medium'
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass(["hound-card avatar", `
                avatar-component-${hound.extensionTraits ? hound.extensionTraits : hound.head[3]}-${hound.color[3]}
                avatar-neon-${hound.extensionTraits ? hound.extensionTraits : hound.head[3]}-${hound.color[2]}
              `])
                            }, [
                              _createElementVNode("div", null, [
                                _hoisted_20,
                                _hoisted_21,
                                _hoisted_22,
                                _createElementVNode("div", _hoisted_23, [
                                  _createVNode(_component_n_space, { align: "center" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("strong", null, _toDisplayString(hound.name), 1),
                                      _createTextVNode(" " + _toDisplayString(hound.firstPlace) + "/" + _toDisplayString(hound.secondPlace) + "/" + _toDisplayString(hound.thirdPlace), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]),
                              _createVNode(_component_n_text, { class: "gender-label" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(hound.sex), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_n_text, { class: "cost-label" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_24, [
                                    _createVNode(_component_n_text, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.formatNumberDecimals(_ctx.eth.utils.formatEther(hound.breedingFee))) + " ", 1),
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.currencyName), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    (_ctx.exchangeRatesAvailable && _ctx.exchangeRates[_ctx.externalBreedingFeeCurrency])
                                      ? (_openBlock(), _createBlock(_component_n_text, {
                                          key: 0,
                                          depth: "3"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.convertToUSD(_ctx.formatNumberDecimals(_ctx.eth.utils.formatEther(hound.breedingFee)), false, _ctx.externalBreedingFeeCurrency)) + " ", 1),
                                            _hoisted_25
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_n_space, { justify: "right" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_n_button, {
                                    type: "primary",
                                    ghost: "",
                                    class: "mount-btn",
                                    onClick: _withModifiers(($event: any) => (_ctx.mount(hound.id, hound.token_id, hound.breedingFee.toString())), ["stop"])
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_26
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024)
                            ], 2)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "size"]))
                      }), 128)),
                      _createVNode(_component_n_space, { justify: "center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_n_pagination, {
                            page: _ctx.page,
                            "onUpdate:page": [
                              _cache[8] || (_cache[8] = ($event: any) => ((_ctx.page) = $event)),
                              _cache[10] || (_cache[10] = ($event: any) => (_ctx.changePagination($event)))
                            ],
                            "page-size": _ctx.pageSize,
                            "onUpdate:page-size": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.pageSize) = $event)),
                            "item-count": _ctx.totalHounds,
                            "show-size-picker": "",
                            "page-sizes": [5, 10, 25, 50],
                            "page-slot": 7,
                            style: {"margin":"2.5rem 0"},
                            "onUpdate:pageSize": _cache[11] || (_cache[11] = ($event: any) => (_ctx.changePagination($event, true)))
                          }, null, 8, ["page", "page-size", "item-count"])
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createBlock(_component_n_alert, {
                      key: 1,
                      type: "warning"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_space, { justify: "space-between" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_n_text, null, {
                              default: _withCtx(() => [
                                _hoisted_27
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_n_button, {
                              type: "primary",
                              onClick: _ctx.resetFilters,
                              text: ""
                            }, {
                              default: _withCtx(() => [
                                _hoisted_28
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        })),
    _createVNode(_component_n_divider),
    _createVNode(_component_n_modal, {
      show: _ctx.showListModal,
      "onUpdate:show": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.showListModal) = $event)),
      style: {"width":"max-content"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_breeding_list_dialog, {
          onListHound: _ctx.resetHounds,
          class: "modal",
          onCancel: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showListModal=false))
        }, null, 8, ["onListHound"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_n_modal, {
      show: _ctx.showInternalModal,
      "onUpdate:show": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.showInternalModal) = $event)),
      style: {"width":"max-content"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_breeding_internal_dialog, {
          onBredHounds: _ctx.resetHounds,
          class: "modal",
          onCancel: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showInternalModal=false))
        }, null, 8, ["onBredHounds"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_n_modal, {
      show: _ctx.showMountModal,
      "onUpdate:show": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.showMountModal) = $event)),
      style: {"width":"max-content"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_breeding_mount_dialog, {
          onMountHound: _ctx.resetHounds,
          class: "modal",
          breedingFee: _ctx.mountFee,
          houndId: _ctx.mountId,
          houndTokenId: _ctx.mountTokenId,
          onCancel: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showMountModal=false))
        }, null, 8, ["onMountHound", "breedingFee", "houndId", "houndTokenId"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}